export const Form = {
  name: {
    component: 'FormText',
    label: 'Name',
    rules: { required: false },
    defaultValue: ''
  },
  desc: {
    component: 'FormMarkdown',
    label: 'Description',
    defaultValue: ''
  },
  image: {
    component: 'FormImage',
    label: 'Image',
    rules: { required: false },
    defaultValue: ''
  },
  startDate: {
    component: 'FormDate',
    label: 'Start date',
    defaultValue: new Date()
  },
  endDate: {
    component: 'FormDate',
    label: 'End date',
    defaultValue: null
  },
  championshipId: {
    component: 'FormSelectChampionship',
    label: 'Championship',
    rules: { required: true },
    defaultValue: null
  },
  wrestlerIds: {
    component: 'FormWrestlerList',
    label: 'Champions',
    rules: { minLength: 1 },
    defaultValue: []
  },
  defenses: {
    component: 'FormNumber',
    label: 'Defenses',
    defaultValue: 0
  }
}

export const RelationForm = {
  championshipId: {
    component: 'FormSelectChampionship',
    label: 'Championship',
    rules: { required: false },
    defaultValue: null
  },
  wrestlerIds: {
    component: 'FormWrestlerList',
    label: 'Champions',
    rules: { minLength: 1 },
    defaultValue: []
  }
}

export const QuickForm = {
  name: {
    component: 'FormText',
    label: 'Name',
    rules: { required: false },
    defaultValue: ''
  }
}

export default Form
